import { createRouter, createWebHistory } from 'vue-router';
import SplashView from './views/mobile/SplashView.vue';
import AuthView from './views/mobile/AuthView.vue';
import HomeView from './views/mobile/HomeView.vue';
import AccountTopUpView from './views/mobile/AccountTopUpView.vue';
import OpenCardView from './views/mobile/OpenCardView.vue';
import CardRechargeView from './views/mobile/CardRechargeView.vue';
import CardsView from './views/mobile/CardsView.vue';
import TransactionsView from './views/mobile/TransactionsView.vue';
import OtpView from './views/mobile/OtpView.vue';
import WithdrawView from './views/mobile/WithdrawView.vue';
import AdminLoginView from './views/admin/AdminLoginView.vue';
import AdminLayout from './views/admin/AdminLayout.vue';
import AdminDashboardView from './views/admin/AdminDashboardView.vue';
import AdminUsersView from './views/admin/AdminUsersView.vue';
import AdminCardsView from './views/admin/AdminCardsView.vue';
import AdminTransactionsView from './views/admin/AdminTransactionsView.vue';
import AdminApiView from './views/admin/AdminApiView.vue';
import AdminSettingsView from './views/admin/AdminSettingsView.vue';
import AdminAuditView from './views/admin/AdminAuditView.vue';
import PlatformEntryView from './views/mobile/PlatformEntryView.vue';
import { api } from './services/api';
import { captureUrlDeviceId } from './services/device-id';

// 必须在 createWebHistory 读取初始地址前消费并清除 URL 中的 deviceId。
captureUrlDeviceId();

const routes = [
  { path: '/', redirect: '/splash' },
  { path: '/splash', component: SplashView },
  { path: '/login', component: AuthView, props: { mode: 'login' } },
  { path: '/register', component: AuthView, props: { mode: 'register' } },
  { path: '/platform-entry', component: PlatformEntryView },
  { path: '/home', component: HomeView, meta: { requiresAuth: true } },
  { path: '/topup', component: AccountTopUpView, meta: { requiresAuth: true } },
  { path: '/open-card', component: OpenCardView, meta: { requiresAuth: true } },
  { path: '/card-recharge', component: CardRechargeView, meta: { requiresAuth: true } },
  { path: '/cards', component: CardsView, meta: { requiresAuth: true } },
  { path: '/transactions', component: TransactionsView, meta: { requiresAuth: true } },
  { path: '/otp', component: OtpView, meta: { requiresAuth: true } },
  { path: '/withdraw', component: WithdrawView, meta: { requiresAuth: true } },
  { path: '/admin/login', component: AdminLoginView },
  {
    path: '/admin',
    component: AdminLayout,
    redirect: '/admin/dashboard',
    children: [
      { path: 'dashboard', component: AdminDashboardView, meta: { title: 'dashboard' } },
      { path: 'users', component: AdminUsersView, meta: { title: 'users' } },
      { path: 'cards', component: AdminCardsView, meta: { title: 'cards' } },
      { path: 'transactions', component: AdminTransactionsView, meta: { title: 'transactions' } },
      { path: 'api', component: AdminApiView, meta: { title: 'apiMonitor' } },
      { path: 'settings', component: AdminSettingsView, meta: { title: 'settings' } },
      { path: 'audit', component: AdminAuditView, meta: { title: 'audit' } }
    ]
  },
  { path: '/:pathMatch(.*)*', redirect: '/home' }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 })
});

router.beforeEach(async (to) => {
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const token = localStorage.getItem('u1card-admin-token');
    if (!token) return { path: '/admin/login', query: { redirect: to.fullPath } };
    try {
      await api.adminSession(token);
      return true;
    } catch {
      localStorage.removeItem('u1card-admin-token');
      return { path: '/admin/login', query: { redirect: to.fullPath } };
    }
  }
  if (to.meta.requiresAuth) {
    const token = localStorage.getItem('u1card-session-token');
    if (!token) return { path: '/login', query: { redirect: to.fullPath } };
    try {
      await api.session();
      if (to.path === '/withdraw') {
        const result = await api.features();
        if (!result.features?.cardWithdrawal) return { path: '/home' };
      }
      return true;
    } catch {
      localStorage.removeItem('u1card-session-token');
      localStorage.removeItem('u1card-profile');
      return { path: '/login', query: { redirect: to.fullPath } };
    }
  }
  return true;
});

export default router;
